import FeatureFlag from './feature-flag';

export default FeatureFlag;
